<template>
	<page>
		<module>
			<view-list ref="view" :work-type="workType" :view-config="saasInfo.viewmanage" :summed="false" @load="loadSummary">
				<template #search>
					<m-search ref="search" :extend-data="defaultSearchData">
						<!-- 平台其它账户汇总（小黑优品保证金 / 小黑专业回收收入） -->
						<div class="stats-bar flex">
							<div class="stats-card card-blue">
								<div class="stats-info">
									<div class="stats-title-row flex-start-center">
										<span class="stats-label">小黑优选保证金收益</span>
										<span class="stats-value">{{formatPrice(summary.deposit_earnings)}}</span>
									</div>
								</div>
								<div class="stats-icon">元</div>
							</div>
                            <div class="stats-card card-orange">
								<div class="stats-info">
									<div class="stats-title-row flex-start-center">
										<span class="stats-label">小黑优选VIP收益</span>
										<span class="stats-value">{{formatPrice(summary.vip_earnings)}}</span>
									</div>
								</div>
								<div class="stats-icon">元</div>
							</div>
						</div>

						<m-search-item label="流水号">
							<c-input name="record_number"></c-input>
						</m-search-item>
						<m-search-item label="会员手机号">
							<c-input name="phone"></c-input>
						</m-search-item>
						<m-search-item label="会员昵称">
							<c-input name="user_realname"></c-input>
						</m-search-item>
                        <m-search-item label="创建时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button v-if="auth('b_platform_other_account_export')"
							  prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出
					</c-button>
				</template>

                <!--收支类型-->
                <template #income_expenses="{data}">
                    <c-state tag async dict="INCOME_EXPENSES" :value="data.income_expenses"></c-state>
                </template>

				<!--变动金额（金额由后端实体 getMoney 分转元，负数标红）-->
                <template #money="{data}">
                    <span v-if="data.income_expenses == 1" style="color: green">￥+{{data.money}}</span>
                    <span v-if="data.income_expenses == 2" style="color: red">￥{{data.money}}</span>
                </template>
				<!--当前金额（金额由后端实体 getSurplus_money 分转元）-->
				<template #surplus_money="{data}">
					￥{{data.surplus_money}}
				</template>

				<!--汇总统计：后端按当前筛选口径对全量数据聚合（收入累加、支出扣减），与分页无关-->
				<template #foot>
					<div class="summary-bar flex-start-center">
						<span class="summary-item">收入合计<span class="summary-value income">{{ incomeText }}</span></span>
						<span class="summary-item">支出合计<span class="summary-value expense">{{ expenseText }}</span></span>
						<span class="summary-item">净额<span class="summary-value" :class="netClass">{{ netText }}</span></span>
					</div>
				</template>
			</view-list>
		</module>
	</page>
</template>

<script>
import {mapState} from 'vuex'

export default {
	name: 'p_platform_other_account',

	data() {
		return {
			workType: 127,
			//平台其它账户汇总（小黑优品保证金 单位：元）
			summary: {},
			//资金收支汇总（当前筛选口径全局统计，与分页无关）
			netSummary: {},
			//来源渠道（流水表 client_source 存储 ClientSourceEnum 中文名称）
			clientSourceOptions: [
				{name: '小黑靓机', value: '小黑靓机'},
				{name: '小黑回收', value: '小黑回收'}
			],
			defaultSearchData: {
                trans_states:[1,3],   //不展示【2：处理中】的记录
                account_type: 10,     //默认查询-平台其他账账户
				user_type: 0          //表示平台
			}
		}
	},

	computed: {
		...mapState(['saasInfo']),
		incomeText() {
			const val = parseFloat(this.netSummary.income_money);
			return isNaN(val) ? '￥0.00' : '￥' + val.toFixed(2);
		},
		expenseText() {
			const val = parseFloat(this.netSummary.expense_money);
			return isNaN(val) ? '￥0.00' : '￥' + val.toFixed(2);
		},
		netText() {
			const val = parseFloat(this.netSummary.net_money);
			if (isNaN(val)) return '￥0.00';
			return (val > 0 ? '+' : '') + '￥' + Math.abs(val).toFixed(2);
		},
		netClass() {
			const val = parseFloat(this.netSummary.net_money);
			return isNaN(val) || val == 0 ? '' : (val > 0 ? 'income' : 'expense');
		}
	},

	methods: {
		/**
		 * 加载平台其它账户汇总（顶部汇总卡片，按来源渠道汇总会员收支）
		 */
        loadSummary(listData, searchParams) {
            this.request({
                url: '/financial/platform/other/account/summary',
                data: searchParams || {},
                success: data => {
                    this.summary = data || {};
                }
            });
            //累计资金变化与列表同筛选口径：后端对全量数据聚合（收入累加、支出扣减），随搜索条件联动刷新
            this.request({
                url: '/account/record/summary',
                data: Object.assign({}, searchParams),
                success: data => {
                    this.netSummary = data || {};
                }
            });
        },
        /**
		 * 金额格式化（分转元后展示）
		 */
		formatPrice(price) {
			if (price === null || price === undefined || price === '') return '-';
			return '￥' + parseFloat(price).toFixed(2);
		}
	}
}
</script>

<style lang="stylus" scoped>
	.summary-bar {
		flex-shrink: 0;
		gap: 32px;
		border-top: 1px solid #F5F5F5;
		padding: 8px 12px;
		font-size: 13px;
		color: #666;

		.summary-item {
			display: inline-flex;
			align-items: baseline;

			.summary-value {
				margin-left: 6px;
				font-size: 16px;
				font-weight: bold;

				&.income {
					color: #67C23A;
				}

				&.expense {
					color: #F56C6C;
				}
			}
		}
	}

	.stats-bar {
		flex-wrap: wrap;
		gap: 10px;
		width: 100%;
		border-top: 1px solid #F5F5F5;
		padding: 8px 12px;

		.stats-card {
			position: relative;
			display: flex;
			align-items: center;
			justify-content: space-between;
			flex: 1 1 260px;
			max-width: 550px;
			min-height: 56px;
			padding: 8px 16px;
			border-radius: 6px;
			color: #fff;
			box-sizing: border-box;
			overflow: hidden;

			&.card-blue {
				background: linear-gradient(90deg, #2563eb, #3b82f6);
			}

			&.card-orange {
				background: linear-gradient(90deg, #f97316, #fb923c);
			}

			.stats-info {
				position: relative;
				z-index: 1;

				.stats-title-row {
					display: flex;
					align-items: baseline;
					line-height: 24px;

					.stats-label {
						font-size: 12px;
						opacity: 0.95;
					}

					.stats-value {
						margin-left: 6px;
						font-size: 18px;
						font-weight: bold;
					}
				}
			}

			.stats-icon {
				position: absolute;
				right: 14px;
				top: 50%;
				transform: translateY(-50%);
				font-size: 32px;
				line-height: 1;
				opacity: 0.15;
			}
		}
	}

	.amount-negative {
		color: #f00;
	}
</style>
